import { EnvironmentUrls } from 'Roblox';

export const urlConstants = {
  qualifiedSignup: `${EnvironmentUrls.apiGatewayUrl}/affiliate-links/v1/events/qualified-signup`
};
export const allowedPathnames = ['/share-links'];
export const allowedLinkTypes = ['ExperienceAffiliate'];
export const expiryTimeout = 200;
